export default __webpack_public_path__ + "assets/170815f599dd6672cacbb3c511149e4d.svg";